import React from "react";
import { Upload, message } from "antd";
import { Storage } from "aws-amplify";
import compose from "lodash/flowRight";
import { graphql } from "react-apollo";
import { getImageType } from "../../../../core/utils/general/strings";

import CREATE_MEDIA_ADMIN from "../../../../core/GraphQl/Mutations/CREATE_MEDIA_ADMIN";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

const getUploadedFileDimensions = file =>
  new Promise((resolve, reject) => {
    try {
      let img = new Image();

      img.onload = () => {
        const width = img.naturalWidth;
        const height = img.naturalHeight;

        window.URL.revokeObjectURL(img.src);

        return resolve({ width, height });
      };

      img.src = window.URL.createObjectURL(file);
    } catch (exception) {
      return reject(exception);
    }
  });

const DragUploader = ({
  onChangeArrayOfObj,
  adUnit,
  createMediaMutation,
  index,
  loading,
  disabled,
  onChange,
  handleUpdateCampaignOrder,
}) => {
  const results = [];
  const uploaderProps = {
    name: "file",
    action: null,
    multiple: true,
    beforeUpload: async (file, fileList) => {
      onChange("loading", true);
      let nextBannersState = adUnit.banners.slice();
      // Get image width and height
      const {
        width: imageWidth,
        height: imageHeight,
      } = await getUploadedFileDimensions(file);

      // Put uploaded image into assets S3 bucket
      const { name, type, size } = file;

      if (size > 2000000) {
        message.error("File can't exceed 2MB");
        onChange("loading", false);
        return;
      }

      const fname = file.name + new Date();
      const response = await Storage.put(fname, file, {
        contentType: "image/*",
      });
      const { key } = response;
      const url = await Storage.get(response.key, { expires: 600000 });

      // Put S3 image into MySQL DB
      results.push(
        createMediaMutation({
          variables: {
            mediatype: "STILL",
            key,
            url,
            width: imageWidth,
            height: imageHeight,
            name,
            size,
            fileType: getImageType(type),
          },
        })
      );

      if (results.length === fileList.length) {
        Promise.all(results).then(async values => {
          onChange("loading", false);
          values.forEach(value => {
            // Add to local state
            nextBannersState.push(value.data.createMedia);
            onChangeArrayOfObj("adUnits", index, "banners", nextBannersState);

            message.destroy();
            message.success("Creatives successfully processed");
          });

          handleUpdateCampaignOrder({ step: "creatives" });
        });
      }
    },
    showUploadList: false,
    accept: ".png, .jpeg, .jpg, .mp4, .gif, .avif",
    customRequest: async () => {
      setTimeout(() => {
        return true;
      }, 0);
    },
  };
  return (
    <Dragger disabled={disabled || false} {...uploaderProps}>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <p>Drag a file to this area to upload a banner.</p>
    </Dragger>
  );
};

export default compose(
  graphql(CREATE_MEDIA_ADMIN, { name: "createMediaMutation" })
)(DragUploader);
